module.exports = __webpack_public_path__ + "static/media/IMG_9956.27f6fcea.JPG";